export default __webpack_public_path__ + "static/media/1537.64036ce0.png";